"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class DcSession extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dcSession';
        this._startTime = initParams.start_time;
        this._endTime = initParams.end_time;
        this._priceCap = initParams.price_cap;
        this._chargePointId = initParams.charge_point_id;
        this._status = initParams.status;
        this._invoiceDetails = initParams.invoice_details;
        this._reasonForEnd = initParams.reason_for_end;
        this._totalCost = initParams.total_cost;
        this._totalUsage = initParams.total_usage;
        this._priceCapFormatted = initParams.price_cap_formatted;
        this._totalCostFormatted = initParams.total_cost_formatted;
        this._totalUsageFormatted = initParams.total_usage_formatted;
    }
    set startTime(value) {
        console.error('Do not set objects this way');
    }
    get startTime() {
        return this._startTime;
    }
    set endTime(value) {
        console.error('Do not set objects this way');
    }
    get endTime() {
        return this._endTime;
    }
    set priceCap(value) {
        console.error('Do not set objects this way');
    }
    get priceCap() {
        return this._priceCap;
    }
    set chargePointId(value) {
        console.error('Do not set objects this way');
    }
    get chargePointId() {
        return this._chargePointId;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
    set invoiceDetails(value) {
        console.error('Do not set objects this way');
    }
    get invoiceDetails() {
        return this._invoiceDetails;
    }
    set reasonForEnd(value) {
        console.error('Do not set objects this way');
    }
    get reasonForEnd() {
        return this._reasonForEnd;
    }
    set totalCost(value) {
        console.error('Do not set objects this way');
    }
    get totalCost() {
        return this._totalCost;
    }
    set totalUsage(value) {
        console.error('Do not set objects this way');
    }
    get totalUsage() {
        return this._totalUsage;
    }
    set priceCapFormatted(value) {
        console.error('Do not set objects this way');
    }
    get priceCapFormatted() {
        return this._priceCapFormatted;
    }
    set totalCostFormatted(value) {
        console.error('Do not set objects this way');
    }
    get totalCostFormatted() {
        return this._totalCostFormatted;
    }
    set totalUsageFormatted(value) {
        console.error('Do not set objects this way');
    }
    get totalUsageFormatted() {
        return this._totalUsageFormatted;
    }
    delete() {
        return this.dataService.deleteDcSession(this.id, this);
    }
}
exports.default = DcSession;
//# sourceMappingURL=dcSession.js.map